import { render } from "./securityRole.vue?vue&type=template&id=612321c3"
import script from "./securityRole.vue?vue&type=script&lang=js"
export * from "./securityRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__